import React from 'react';
import TopFooter from "../components/common/TopFooter";

const Footer = () => {
 
  return (
    <>
    <TopFooter/>
    </>
  )
}

export default Footer